angular.module('main').directive('btnUrl', () => ({
	restrict: 'AE',
	scope: {
		text: '@snText'
	},
	template:
		'<button class="btn btn-default"><i class="fi fa fa-link"></i>{{text}}</button>',
	replace: true,
	transclude: true,
	link(scope) {
		scope.text = scope.text || 'Get URL';
	}
}));



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnUrl.js